//Components
import TranslationText from "../../atoms/TranslationText";
//Styles
import "./styles.scss";

function LeftContainer() {
  return (
    <div className="left-container">
      <div className="left-container__image-container">
        <img
          className="left-container__image"
          src="/assets/undraw_developer.png"
          alt="undraw-developer"
        />
      </div>
      <div className="left-container__data-container">
        <TranslationText
          styles="left-container__greeting"
          jsonKeysPath="home.greeting"
        />
        <TranslationText
          styles="left-container__profile"
          jsonKeysPath="home.profile"
        />
      </div>
    </div>
  );
}

export default LeftContainer;
